import { useEffect, useState } from "react";
import { Toast } from "../../types/type";
import styled, { keyframes } from "styled-components";

function ToastItem(props: Toast) {
  const { content, bottom, duration } = props;
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const setExistTimeout = setTimeout(() => {
      setIsClosing(true);
      clearTimeout(setExistTimeout);
    }, duration ?? 1000);
  });

  return (
    <StToastItem bottom={bottom} isClosing={isClosing}>
      <span style={{ textWrap: "nowrap" }}>{content}</span>
    </StToastItem>
  );
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const StToastItem = styled.div<{ bottom?: number; isClosing: boolean }>`
  position: absolute;
  padding: 24px;
  bottom: ${({ bottom }) => bottom ?? 26}px;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  animation: ${({ isClosing }) => (isClosing ? fadeOut : fadeIn)} 1s ease-in-out;
  opacity: ${({ isClosing }) => (isClosing ? 0 : 1)};
  transition: opacity 0.5s ease-in-out;
  display: flex;
  justify-content: center;
`;
export default ToastItem;
